/**
 * Ask Aardvark starter prompts — single source of truth for the in-app modal.
 * When MCP tools are added or changed, update this list in the same change.
 */

export interface AskAardvarkPromptGroup {
  title: string;
  tip?: string;
  prompts: string[];
}

export const askAardvarkPromptGroups: AskAardvarkPromptGroup[] = [
  {
    title: 'Everyone',
    tip: 'Swap 2026 for the year you care about, or leave the year out to use the current one.',
    prompts: [
      'What’s on my Tasks list right now?',
      'Show my leave for 2026.',
      'Have I met my statutory annual leave for this year?',
      'When is my next check-in, and am I overdue?',
      'What’s in the public holiday calendar for 2026?',
      'Give me the Workforce snapshot for my team — headcount, tenure, and who has a birthday this month.',
    ],
  },
  {
    title: 'Managers and team leads',
    prompts: [
      'Show leave for my team for 2026, direct reports only.',
      'Who on my team is behind on statutory annual leave?',
      'How are my team’s check-ins looking — overdue, upcoming, needing a decision?',
      'Who on my team hasn’t got a development plan yet?',
    ],
  },
  {
    title: 'Administrators and senior managers',
    tip: 'Senior managers see only their reporting line unless they have no manager.',
    prompts: [
      'Give me an All Reviews extract for people still at the company in 2026. One row per person, with Q1, Q2 and Q3 final results, then each measure’s rating for each quarter. Leave a quarter blank if they have no review. Include Q4 if we have a cycle for it.',
      'How healthy is the current review cycle — completion, pending by department, and managers that might need coaching?',
      'Who hasn’t got a development plan this year?',
      'Who in the organisation is high risk on statutory annual leave?',
      'How are organisation check-ins looking, including manager headcount / review load?',
      'Organisation leave for 2026.',
    ],
  },
  {
    title: 'Administrators only',
    prompts: [
      'List the review cycles, then show the outstanding chase list for the current one — self-reviews, manager reviews, and peer emails still outstanding.',
    ],
  },
];
